import React from 'react';

const Projects: React.FC = () => {
    return (
        <div>
        </div>
    );
}; export default Projects; // By John Michael
